module.exports = __webpack_public_path__ + "img/zhengzaikaifa.96051455.png";